<template>
    <header class="header">
        <Logo class="header__logo" width="148" height="24" />
        <div class="header__center">
            <portal-target name="header-after-logo" multiple />
            <button v-if="canToBack" type="button" class="header__back" @click="back">
                {{ !title ? $t('misc.back') : '' }}
            </button>
            <div v-if="$slots.title || title" class="header__title">
                <slot name="title">
                    <span>
                        {{ title }}
                    </span>
                    <div v-if="subtitle" class="header__subtitle">{{ subtitle }}</div>
                </slot>
            </div>
            <slot name="center" />
            <DocsDropdown v-if="!isCrm && !isListener" />
            <SupportForm v-if="!isCrm && !isListener" />
            <slot name="header-after-support" />
        </div>
        <div class="header__right">
            <slot name="header-before-idea" />
            <SupportForm v-if="!isListener && !$isCrmApp" idea />
            <slot name="right" />
            <!-- <LocaleChanger v-if="!$isCrmApp" /> -->
            <NotificationsWidget v-if="$isCrmApp" />
            <ProfileWidget />
        </div>
    </header>
</template>

<script>
import Logo from '@speechki-frontend/shared/ui/layout/Logo';
import { ProfileWidget } from '@speechki-frontend/core/auth/components';
// import { LocaleChanger } from '@speechki-frontend/core/i18n/components';
import DocsDropdown from '@speechki-frontend/shared/ui/DocsDropdown';
import SupportForm from '@speechki-frontend/shared/ui/SupportForm';
import { NotificationsWidget } from '@speechki-frontend/crm/src/notifications/components';

export default {
    name: 'Header',
    components: {
        Logo,
        ProfileWidget,
        DocsDropdown,
        SupportForm,
        // LocaleChanger,
        NotificationsWidget
    },
    props: {
        title: {
            type: String,
            default: undefined
        },
        subtitle: {
            type: String,
            default: undefined
        },
        // temporary prop hiding docs dropdown and other editor specific components
        // until we find a better way to work with layout components
        isCrm: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showTooltip: false
        };
    },
    computed: {
        isListener() {
            return this.$store.getters.isListener;
        },
        canToBack() {
            return this.$route.path !== '/';
        }
    },
    methods: {
        back() {
            this.$emit('back');
        }
    }
};
</script>

<style lang="scss" src="./Header.scss"></style>
